(function () {
  var data = window.ezBackorderData || {};
  var block = document.getElementById('ezBackorderBlock');
  if (!block) return;

  // Hydrate hidden fields from Liquid-injected data
  var productField = document.getElementById('ez-bo-product-field');
  var skuField = document.getElementById('ez-bo-sku-field');
  var subjectField = document.getElementById('ez-bo-subject-field');

  if (productField) productField.value = (data.productTitle || '') + ' — ' + (data.productUrl || '');
  if (skuField) skuField.value = data.sku || '';
  if (subjectField) subjectField.value = 'Backorder Expedite Request — ' + (data.productTitle || '');

  // Pre-fill qty from selected variant (use 1 as fallback if qty is 0 or negative)
  var qtyInput = document.getElementById('ez-bo-qty');
  if (qtyInput) qtyInput.value = data.defaultQty > 0 ? data.defaultQty : 1;

  // Toggle
  var toggleBtn = document.getElementById('ezBoToggleBtn');
  var formWrap = document.getElementById('ezBoFormWrap');

  if (toggleBtn && formWrap) {
    toggleBtn.addEventListener('click', function () {
      var isOpen = formWrap.classList.toggle('open');
      toggleBtn.textContent = isOpen ? 'Hide ▲' : 'Need it sooner? ▼';
    });
  }
})();